import type { Movie } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import { Link } from 'react-router-dom';

interface FeaturedSectionProps {
  title: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function FeaturedSection({ title, movies, viewAllLink }: FeaturedSectionProps) {
  return (
    <section className="mb-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
          {title}
        </h2>
        {viewAllLink && (
          <Link
            to={viewAllLink}
            className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}